import { render, staticRenderFns } from "./ItemClassRoomListView.vue?vue&type=template&id=dee01d04&scoped=true&"
import script from "./ItemClassRoomListView.vue?vue&type=script&lang=js&"
export * from "./ItemClassRoomListView.vue?vue&type=script&lang=js&"
import style0 from "./ItemClassRoomListView.vue?vue&type=style&index=0&id=dee01d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee01d04",
  null
  
)

export default component.exports